"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isRouterResult;
function isRouterResult(reactElementOrRouterResult) {
  return !!(reactElementOrRouterResult.redirectLocation || reactElementOrRouterResult.error);
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-on-rails/node_package/lib/isRouterResult.js
 ** module id = 317
 ** module chunks = 0
 **/